/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyFileResponseDTO
 */
export interface SurveyFileResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof SurveyFileResponseDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyFileResponseDTO
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyFileResponseDTO
     */
    filename: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyFileResponseDTO
     */
    order: number;
}

export function SurveyFileResponseDTOFromJSON(json: any): SurveyFileResponseDTO {
    return SurveyFileResponseDTOFromJSONTyped(json, false);
}

export function SurveyFileResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyFileResponseDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'path': json['path'],
        'filename': json['filename'],
        'order': json['order'],
    };
}

export function SurveyFileResponseDTOToJSON(value?: SurveyFileResponseDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'path': value.path,
        'filename': value.filename,
        'order': value.order,
    };
}

